import { Navigate, useLocation } from 'react-router-dom'
import { useUser } from 'app/User'
import PermissionDenied from 'components/PermissionDenied'
import { Role } from 'common/types'
import { hasValidGuestToken } from 'lib/services/restApi/getAccessToken'

interface Props {
  children: JSX.Element
  roles?: Role[]
  isPermitted?: boolean
  allowGuest?: boolean
}

const ProtectedUserRoute = ({
  children,
  roles,
  isPermitted,
  allowGuest = false,
}: Props) => {
  let location = useLocation()

  const { user, isAuthenticated, isGuest } = useUser()

  // Check if the route allows guest access and the user is a guest
  const guestIsPermitted = allowGuest && (isGuest || hasValidGuestToken())

  const userIsPermitted =
    isPermitted ||
    guestIsPermitted ||
    (roles && roles?.some((role) => user?.roles?.includes(role)))

  if (!isAuthenticated && !guestIsPermitted) {
    return <Navigate to="/" state={{ from: location }} />
  }

  if (!userIsPermitted) {
    return <PermissionDenied />
  }

  return children
}

export default ProtectedUserRoute
